import { FunctionComponent, ReactNode, createContext, useState } from 'react'

export const PageTitleContext = createContext<(value: string | undefined) => void>(() => {})

const PageTitleProvider: FunctionComponent<{ children: ReactNode }> = ({ children }) => {
  const [title, setTitle] = useState<string | undefined>(undefined)
  const setPageTitle = (value: string | undefined) => {
    if (value) {
      setTitle(value)
    }
  }

  return (
    <PageTitleContext.Provider value={setPageTitle}>
      <title>{title ? `${title} - Data en informatie` : 'Data en informatie'}</title>
      {children}
    </PageTitleContext.Provider>
  )
}

export default PageTitleProvider
